var styles = {
raw: ".hcr-mark-13-6-1{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color)}",
map:{"hcr-mark":"hcr-mark-13-6-1"}};

export { styles as default };
